import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Types
import Reducers from 'types/Reducers';

interface IState {
  snackbarMessage: string | null;
  tracking: {
    advertClick: boolean;
  }
  appSyncEventsConfig: any;
};

const initialState:IState = {
  snackbarMessage: null,
  tracking: {
    advertClick: false
  },
  appSyncEventsConfig: null
};

const slice = createSlice({
  name: Reducers.UI,
  initialState,
  reducers: {
    setSnackbarMessage: (state, action:PayloadAction<string | null>) => {
      state.snackbarMessage = action.payload;
    },
    setTrackingAdvertClick: (state) => {
      state.tracking.advertClick = true
    },
    setAppSyncEventsConfig: (state, action:PayloadAction<any>) => {
      state.appSyncEventsConfig = action.payload;
    }
  },
  extraReducers(builder) {
    
  }
});

export const { setSnackbarMessage, setTrackingAdvertClick, setAppSyncEventsConfig } = slice.actions;

export default slice.reducer;
